import React from 'react';

function StrongerTomorrowSection() {
  const styles = {
    section: { padding: '80px 48px 80px', background: '#fff', display: 'flex', gap: 24, alignItems: 'center', flexWrap: 'wrap', width: '100%', maxWidth: 1920, boxSizing: 'border-box', margin: '0 auto' },
    leftCol: { flex: '1 1 480px', minWidth: 300 },
    subheadingBlock: { marginBottom: 16, display: 'flex', alignItems: 'center', gap: 12 },
    offerText: {
      fontFamily: 'Lato', fontWeight: 400, fontSize: '16px', lineHeight: '100%',
      letterSpacing: '-0.01em', textTransform: 'uppercase', color: '#838383',
      margin: 0
    },
    accentLine: { width: 80, height: 0, borderTop: '2px solid #E73123', flexShrink: 0, opacity: 1 },
    titleWrap: { marginBottom: 24 },
    titleRed: {
      fontFamily: 'Lato', fontWeight: 700, fontSize: '30px', lineHeight: '110%',
      letterSpacing: 0, textTransform: 'uppercase', color: '#E73123', display: 'inline'
    },
    titleDark: {
      fontFamily: 'Lato', fontWeight: 700, fontSize: '30px', lineHeight: '110%',
      letterSpacing: 0, textTransform: 'uppercase', color: '#090909', display: 'inline'
    },
    paragraph: {
      fontFamily: 'Lato', fontWeight: 400, fontSize: 16, lineHeight: '26px',
      letterSpacing: 0, color: '#838383', margin: '0 0 20px'
    },
    redBox: {
      width: '100%', maxWidth: 700, minHeight: 214, background: '#E73123', color: '#FFFFFF',
      padding: '24px 32px', boxSizing: 'border-box', opacity: 1,
      fontFamily: 'Lato', fontWeight: 400, fontSize: 16, lineHeight: '26px',
      letterSpacing: 0, marginTop: 24
    },
    rightCol: { flex: '1 1 480px', minWidth: 300, display: 'flex', justifyContent: 'flex-end' },
    sectionImage: { width: '100%', maxWidth: 900, maxHeight: 600, height: 'auto', objectFit: 'contain', opacity: 1, display: 'block' }
  };

  const para1 = "At Sunrise Infrabuild Pvt Ltd, strong foundations are the backbone of every successful project. We combine advanced construction equipment, skilled manpower, and engineering-driven execution to deliver infrastructure solutions that are safe, efficient, and built to last.";
  const para2 = "Our experienced engineers and site teams meticulously plan and execute each phase—from ground investigation and foundation works to final completion—ensuring strict adherence to quality, safety, and industry standards. By leveraging modern construction methodologies and proven project management practices, we minimize risks, optimize timelines, and achieve consistent project outcomes.";

  return React.createElement('section', { style: styles.section, className: 'stronger-tomorrow-section' },
    React.createElement('div', { style: styles.leftCol },
      React.createElement('div', { style: styles.subheadingBlock, className: 'stronger-subheading' },
        React.createElement('span', { style: styles.offerText }, 'FOR A STRONGER TOMORROW'),
        React.createElement('div', { style: styles.accentLine, className: 'stronger-accent-line' })
      ),
      React.createElement('div', { style: styles.titleWrap, className: 'stronger-title-wrap' },
        React.createElement('span', { style: styles.titleRed }, 'BUILDING '),
        React.createElement('span', { style: styles.titleDark }, 'STRONG FOUNDATIONS')
      ),
      React.createElement('p', { style: styles.paragraph }, para1),
      React.createElement('p', { style: styles.paragraph }, para2),
      React.createElement('div', { style: styles.redBox },
        "With the capability to handle complex soil conditions and large-scale civil works, Sunrise Infrabuild stands as a reliable partner for infrastructure projects across India."
      )
    ),
    React.createElement('div', { style: styles.rightCol },
      React.createElement('img', {
        src: '/foundation.jpg',
        alt: 'Building strong foundations',
        style: styles.sectionImage
      })
    )
  );
}

export default StrongerTomorrowSection;
